import React, { useState, useEffect, useRef } from 'react'
import useUrlParams from 'hooks/useUrlParams'
import useApiParams from 'hooks/useApiParams'
import classNames from 'classnames'
import IconCheckmark from 'components/partials/IconCheckmark'

function Checkbox({ id, name, value, apiDataParams, entityParams, label, checked, disabled, ariaLabel, modifierContainerClasses = [], modifierContentClasses = [], onSave, isDisabled }) {
  const { urlParams, updateUrlParams } = useUrlParams()
  const { apiParams, removeApiParams, addApiParams } = useApiParams()
  const [facetValue, setFacetValue] = useState(urlParams[id])
  const [facetChecked, setFacetChecked] = useState(false)
  const [facetDisabled, setFacetDisabled] = useState(false)
  const checkboxRef = useRef([])

  const containerClasses = classNames(
    'form-item',
    'form-item--checkbox',
    isDisabled ? "disabled" : "",
    modifierContainerClasses
  )

  const contentClasses = classNames(
    'form-item__input',
    'form-item__input--checkbox',
    {'is-checked': facetChecked},
    {'is-disabled': facetDisabled},
    modifierContentClasses
  )

  useEffect(() => {
    if (!facetValue)
      setFacetValue(value)
  }, [facetValue])

  useEffect(() => {
    if (urlParams[id])
      setFacetChecked(true)
    else
      setFacetChecked(false)
  }, [urlParams[id]])

  const handleChange = () => {
    const value = urlParams[id] ? undefined : facetValue
    const apiParams = checkboxRef.current.getAttribute("data-apiparams");
    const entityParams = checkboxRef.current.getAttribute("data-entityparams")
    
    updateUrlParams({ [id]: value })
    setFacetChecked(!facetChecked)
    setFacetValue(value)

    if (facetChecked) {
      removeApiParams(apiParams, entityParams)
    } else {
      addApiParams(apiParams, entityParams)
    }

    if (onSave) {
      onSave()
    }
  }
  
  return (
    <div className={containerClasses}>
      <input
        aria-label={ariaLabel || label}
        className={contentClasses}
        type="checkbox"
        role="checkbox"
        name={name}
        id={id}
        ref={checkboxRef}
        value={facetValue || value}
        data-apiparams={apiDataParams }
        data-entityparams={entityParams}
        checked={facetChecked || checked}
        disabled={isDisabled ? "disabled" : ""}
        onChange={handleChange}
      />
      <IconCheckmark />
      <label htmlFor={id} className="label u-text-color-secondary u-font-weight-500 u-inline-block u-pl-150">{label}</label>
    </div>
  )
}

export default Checkbox
